<template>
    <div>
        <div v-if="step === 1" class="section-register">
            <div
                class="section-register__header"
                v-if="this.dataNumber.length > 0"
            >
                <div class="register-select-number container">
                    <h1 class="title-number">
                        {{
                            getTranslatedText(
                                `you've successfully selected your first 7 numbers! good luck!`
                            )
                        }}
                    </h1>
                    <div class="box-number">
                        <div class="list-number">
                            <div
                                v-for="(item, index) in dataNumber"
                                :class="`item-number ${renderClass(
                                    item,
                                    index
                                )}`"
                                :key="index"
                            >
                                <span>{{ renderNumber(item) }} </span>
                            </div>
                        </div>
                        <div class="change-number">
                            <button
                                class="btn-no-border t-transform-cap"
                                @click="changeNumber"
                            >
                                {{ getTranslatedText("change number") }}
                            </button>
                        </div>
                    </div>
                </div>
                <h1 class="title-custom-1 t-fir-transform-cap">
                    {{ getTranslatedText(`you've got to be in to win!`) }}
                </h1>
            </div>
            <div class="section-register__left">
                <template v-if="this.dataNumber.length > 0">
                    <div class="section-register__left__title">
                        {{
                            getTranslatedText(
                                `you've successfully selected your first 7 numbers! good luck!`
                            )
                        }}
                    </div>
                    <div class="box-number">
                        <div class="list-number">
                            <div
                                v-for="(item, index) in dataNumber"
                                :class="`item-number ${renderClass(
                                    item,
                                    index
                                )}`"
                                :key="index"
                            >
                                <span>{{ renderNumber(item) }} </span>
                            </div>
                        </div>
                        <div class="change-number">
                            <button
                                class="btn-no-border t-transform-cap"
                                @click="changeNumber"
                            >
                                {{ getTranslatedText("change number") }}
                            </button>
                        </div>
                    </div>
                    <div
                        class="section-register__left__des t-fir-transform-cap"
                    >
                        {{ getTranslatedText(`you’ve got to be in to win!`) }}
                    </div>
                </template>
            </div>
            <div class="form-container section-register__right">
                <h1 class="section-register__right__title t-transform-cap">
                    {{ getTranslatedText("create your account") }}
                </h1>
                <FormCommon
                    :formItem="formItem"
                    :dataForm="dataForm"
                    @on-bur-input="onBurInputFormData"
                    @update-form-data="updateFormData"
                    @onSubmitForm="onSubmitForm"
                    classContainer="section-register__right__form"
                >
                    <div slot="desMethosRes" class="des-method-register">
                        <img src="@/assets/images/info.png" />
                        <p class="description t-fir-transform-cap">
                            {{
                                getTranslatedText(
                                    "email or mobile number mandatory"
                                )
                            }}
                        </p>
                    </div>
                    <b-input-group-prepend
                        slot="propend-phone-number"
                        class="phone-code"
                    >
                        <button
                            class="show-dropdown"
                            type="button"
                            @click="showDropDow"
                        >
                            <img
                                class="user-avatar"
                                :src="
                                    require(`@/assets/images/flags/${dataForm.flag}`)
                                "
                                :alt="dataForm.flag"
                            />
                            <span class="name-country">{{
                                dataForm.nameCountry
                            }}</span>
                            ({{ dataForm.calling_code }})
                        </button>

                        <b-dropdown ref="select_phone_code">
                            <b-form-input
                                v-model="textSearchPhoneNumber"
                                :placeholder="getTranslatedText('search')"
                                @input="onChangeFilterPhoneNumbers"
                            ></b-form-input>
                            <b-dropdown-item
                                @click="selectPhoneCode(item)"
                                v-for="(item, index) in phoneNumbersFilter"
                                :key="index"
                            >
                                <div>
                                    <img
                                        class="user-avatar"
                                        :src="
                                            require(`@/assets/images/flags/${item.flag}`)
                                        "
                                        :alt="item.flag"
                                    />
                                    <span class="name-country">{{
                                        item.name
                                    }}</span>
                                    ({{ item.number }})
                                </div>
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-input-group-prepend>
                    <div class="box-text-or" slot="textOr">
                        <p>{{ getTranslatedText('or') }}</p>
                    </div>
                    <template slot="birthDate">
                        <DateDropdown :default="dataForm.dob" label="date of Birth" min="1920" :max="maxYearBirth" @input="updateDate" :textInvalidFeedback="textInvalidFeedbackDate"/>
                    </template>
                    <div class="box-btn" slot="button">
                        <div
                            class="register-btn"
                            :class="{
                                'have-balls': this.dataNumber.length > 0,
                            }"
                        >
                            <ButtonCustom
                                classBtn="register-btn-close"
                                typeBtn="button"
                                type="default"
                                text="cancel"
                                @onClickButton="onClickCancel"
                            />
                            <ButtonCustom
                                classBtn="register-btn-continue"
                                typeBtn="submit"
                                type="primary"
                                :isLoading="isLoadingButton"
                                text="continue"
                                icon="arrow-right.png"
                            />
                            <!-- <ButtonCustom
                                classBtn="register-btn-login"
                                typeBtn="button"
                                type="default"
                                v-if="this.dataNumber.length > 0"
                                @onClickButton="$router.push('/login')"
                                text="login"
                                icon="arrow-right.png"
                            /> -->
                        </div>
                    </div>
                </FormCommon>
            </div>
        </div>
        <ConfirmOTP
            v-else-if="step === 2"
            :dataSource="dataForm"
            :isLoadingButton="isLoadingButtonOTP"
            @onClickGoBack="onClickGoBack"
            @onSubmitForm="onSubmitConfirmOTp"
            @sendOTP="sendOTP"
            :text="getTranslatedText('enter otp')"
        />
        <SetPassWord
            v-else
            :text="getTranslatedText('set password')"
            :methodLogin="1"
            :isLoadingButton="isLoadingButtonSetPass"
            :textBtnContinue="getTranslatedText('Done')"
            @onClickGoBack="onClickGoBack"
            @on-submit-password="onSubmitResgister"
        />
        <Toast :title="toastData.message" :type="toastData.type" />
    </div>
</template>
<script>
import { setToken } from "@/services/axios";
import { phoneNumbers } from "@/resources/phoneNumber";
import {
    filterFullTextSearch,
    isArrayEmpty,
    isStrEmpty,
    renderLocaleNumber,
    validateEmail,
} from "@/components/common/utils";

import moment from "moment";

import authService from "@/services/auth.service";
import countriesService from "@/services/countries.service";
import toolService from "@/services/tool.service";

import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";
import Toast from "@/components/common/toast/Toast.vue";
import DateDropdown from "@/components/common/date-dropdown/DateDropdown.vue"

import ConfirmOTP from "@/views/mobile/authenticate/ConfirmOTP";
import SetPassWord from "@/views/mobile/authenticate/SetPassword.vue";

import LanguageMixin from "@/mixins/language/language-mixin";
import { isPossiblePhoneNumber, isValidPhoneNumber, getCountryCallingCode, getType } from "libphonenumber-js";
import parseMax from 'libphonenumber-js/max'
export default {
    mixins: [LanguageMixin],
    components: {
        FormCommon,
        ButtonCustom,
        ConfirmOTP,
        SetPassWord,
        Toast,
        DateDropdown
    },
    data() {
        return {
            toastData: {
                message: "",
                type: "success",
            },
            minimumBall: -1,
            maxiumBlue: -1,
            maxiumGreen: -1,
            quatityNumber: -1,
            isLoadingButtonOTP: false,
            isLoadingButtonSetPass: false,
            step: 1,
            dataNumber: [],
            isLoadingButton: false,
            textSearchPhoneNumber: "",
            dataOTPCode: "",
            allCountries: [],
            maxYearBirth: "0",
            maxDate: '',
            textInvalidFeedbackDate: '',
            emailValidate: '',
            phoneValidate: '',
            dataSynerise: {
                firstName: "",
                lastName: "",
                phone: "",
                birthdate: "",
                nationality: "",
                country_of_residence: "",
            },
            dataForm: {
                full_name: "",
                gender: "male",
                calling_code: "+968",
                code: "+968",
                flag: "Flag_of_Oman.svg",
                phone: "",
                email: "",
                nationality: "",
                country_code: "",
                dob: "",
                confirm: true,
                nameCountry: "Oman",
            },
            phoneNumbersFilter: phoneNumbers,
            isRandomBalls: true,
            formItem: [
                {
                    type: "input",
                    typeInput: "text",
                    placeholder: "first | middle (optional) | last",
                    name: "full_name",
                    label: "full name",
                    for: "input-full-name",
                    id: "input-full-name",
                    idFormGroup: "register-fullName",
                    state: null,
                    textInvalid: "please enter full name",
                },
                {
                    type: "radio",
                    name: "gender",
                    required: false,
                    label: "gender",
                    id: "input-gender",
                    options: [
                        { text: this.getTranslatedText("male"), value: "male" },
                        {
                            text: this.getTranslatedText("female"),
                            value: "female",
                        },
                        {
                            text: this.getTranslatedText("not specify"),
                            value: "not-specify",
                        },
                    ],
                },
                {
                    type: "slot",
                    nameSlot: "desMethosRes",
                },
                {
                    type: "input",
                    typeInput: "email",
                    placeholder: "someone@example.com",
                    name: "email",
                    showIconRequired: false,
                    label: "email",
                    description: "a 6 digit otp will be sent to this email",
                    for: "input-email",
                    id: "input-email",
                    idFormGroup: "register-email",
                    state: null,
                    textInvalid: "please enter email",
                },
                {
                    type: "slot",
                    nameSlot: 'textOr'
                },
                {
                    type: "input-group",
                    typeInput: "number",
                    placeholder: "",
                    name: "phone",
                    label: "phone Number",
                    description: "a 6 digit OTP will be sent to this number",
                    for: "input-phone",
                    id: "register-phone",
                    prepend: "code",
                    nameSlotInputPrepend: "propend-phone-number",
                    state: null,
                    textInvalid: "",
                },
                {
                    type: "slot",
                    nameSlot: "birthDate"
                },
                {
                    type: "select",
                    label: "nationality",
                    name: "nationality",
                    required: true,
                    for: "input-nationality",
                    id: "input-nationality",
                    idGroup: "input-group-nationality",
                    options: [],
                },
                {
                    type: "select",
                    label: "country of residence",
                    name: "country_code",
                    required: true,
                    for: "input-country",
                    id: "input-country",
                    idGroup: "input-group-country",
                    options: [],
                },
                {
                    type: "confirm",
                    name: "confirm",
                    id: "input-confirm",
                    text: "i accept the terms and conditions",
                },
            ],
        };
    },
    mounted() {
        this.handleDefaultCountry();
    },
    created() {
        this.fetchDateCountries();
        this.fetDateAgo();
    },
    methods: {
        handleDefaultCountry() {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const ct = require('countries-and-timezones');
            const timezone = ct.getTimezone(tz);
            const userCountry = timezone.countries[0];
            const countryCallingCode = `+${getCountryCallingCode(userCountry)}`;
            this.phoneNumbersFilter.forEach(item=> {
                if(item.number === countryCallingCode) {
                    this.dataForm.calling_code = item.number;
                    this.dataForm.code = item.number;
                    this.dataForm.flag = item.flag;
                    this.dataForm.nameCountry = item.name.replace(
                        /^(.{5}[^\s]*).*/,
                        "$1"
                    );
                }
            })
        },
        handleValidatePhoneNumber(phone) {
            const phoneCallingCode = `${this.dataForm.code}${phone}`
            const isPossiblePhone = isPossiblePhoneNumber(phoneCallingCode) === true;
            const isValidType = parseMax(phoneCallingCode)?.getType() === 'MOBILE';
            const isValidNumber = isValidPhoneNumber(phoneCallingCode) === true
            this.formItem[5].state = isPossiblePhone && isValidNumber && isValidType;
        },
        fetDateAgo() {
            const nowYear = moment().format("YYYY");
            const nowMonthDate = moment().format("MM-DD");
            let yearAgo = `${parseInt(nowYear) - 18}-${nowMonthDate}`;
            this.dataForm.dob = `${parseInt(nowYear) - 18}-${moment().format("MM-DD")}`
            this.maxDate = yearAgo;
            this.maxYearBirth = `${parseInt(nowYear) - 18}`;
        },

        showToast(message, type) {
            this.toastData.message = message;
            this.toastData.type = type;
            this.$bvToast.show("my-toast");
        },
        async fetchDateCountries() {
            try {
                const resp = await countriesService.getCountries();
                const respTool = await toolService.getValidateTicket();

                if (resp.status === 200) {
                    const countries = resp.data.map(({ code, name }) => ({
                        value: code,
                        text: name,
                    }));

                    let number_index = localStorage.getItem("number_index");

                    this.dataNumber = !isStrEmpty(number_index)
                        ? JSON.parse(number_index)
                        : [];

                    this.formItem[7].options = countries;
                    this.formItem[8].options = countries;
                    this.dataForm.nationality = countries[0].value;
                    this.dataForm.country_code = countries[0].value;
                    this.allCountries = resp.data;
                }
                this.minimumBall = respTool.minMaxTickets[0];
                this.maxiumBlue = respTool.maxiumBlue;
                this.maxiumGreen = respTool.maxiumGreen;
                this.quatityNumber = respTool.quatityNumber;
            } catch (error) {
                console.log(error);
            }
        },

        async sendOTP(isShowNoti) {
            let { email, code, nationality } = this.dataForm;

            let phone = this.dataForm.phone;
            let calling_code = `${code.replaceAll("\\+", "")}`;
            let country_code = nationality;

            try {
                const resp = await authService.sendBoth(
                    "register",
                    email,
                    phone,
                    calling_code,
                    country_code
                );

                if (resp.status === 200 && isShowNoti) {
                    this.showToast(
                        this.getTranslatedText(resp.message),
                        "success"
                    );
                }
            } catch (err) {
                console.log(err, "err");
            }
        },

        // call api resgister
        async onSubmitResgister(dataSource) {
            const { password } = dataSource;

            let {
                full_name,
                phone,
                email,
                dob,
                nationality,
                country_code,
                calling_code,
                gender,
            } = this.dataForm;
            let code = this.dataOTPCode;

            this.isLoadingButtonSetPass = true;

            calling_code = calling_code.replaceAll("\\+", "");
            try {
                const resp = await authService.register(
                    full_name,
                    phone,
                    email,
                    password,
                    dob,
                    nationality,
                    country_code,
                    calling_code,
                    gender,
                    code
                );

                if (resp.status === 200) {
                    // eslint-disable-next-line no-undef
                    SR.event.sendFormData("register", {
                        firstname: this.dataSynerise.firstName,
                        lastname: this.dataSynerise.lastName,
                        email: email,
                        phone: this.dataSynerise.phone,
                        sex: gender,
                        birthdate: dob,
                        nationality: this.dataSynerise.nationality,
                        country_of_residence:
                            this.dataSynerise.country_of_residence,
                    });
                    setToken(resp.data.token);


                    let list_block_tmp = !isStrEmpty(localStorage.getItem('list_block_tmp')) ? JSON.parse(localStorage.getItem('list_block_tmp')) : []

                    if(!isArrayEmpty(list_block_tmp)) {
                        let amount = 0;

                        list_block_tmp.map((x) => {
                            amount += x.date.length;
                        });

                        let param = {
                            cart_data: list_block_tmp,
                            items: list_block_tmp.length,
                            amount,
                        };

                        const respSaveCart = await authService.saveListCart(param)
                        console.log(respSaveCart, 'respSaveCart')

                        if (respSaveCart.status === 200) {
                            localStorage.setItem( "list_block_tmp", JSON.stringify(list_block_tmp));
                            localStorage.setItem( "list_block", JSON.stringify(list_block_tmp));
                            localStorage.setItem( "total_items", param.amount);
                            window.location.href = '/checkout'
                        }
                    } else {
                        localStorage.setItem("isRegister", true);
                        localStorage.setItem( "total_items", 0);
                        window.location.href = '/tickets'
                    }
                } else {
                    let message = "";
                    if (!isArrayEmpty(resp.errors)) {
                        resp.errors.forEach((element) => {
                            message += element.message;
                        });
                    } else {
                        message = resp.message;
                    }

                    this.showToast(this.getTranslatedText(message), "error");
                }

                this.isLoadingButtonSetPass = false;
            } catch (error) {
                this.isLoadingButtonSetPass = false;
            }
        },

        // call api check email and phone
        async onBurInputFormData(event, phoneCode, ) {
            const { name, value } = event.target;
            let { calling_code, phone, email } = this.dataForm;

            if (name === "email" && isStrEmpty(value) && !isStrEmpty(phone)) {
                this.dataForm.email = "";
            }

            if(isStrEmpty(phone) && this.formItem[5].state !== null) {
                this.formItem[5].state = null
            }

            switch (true) {
                case name === "email" &&
                    isStrEmpty(value) &&
                    !isStrEmpty(phone) &&
                    this.formItem[3].state !== null:
                    this.formItem[3].state = null;
                    break;
                // check phone no empty
                case this.formItem[3].state !== null &&
                    name === "phone" &&
                    isStrEmpty(email) &&
                    !isStrEmpty(value):
                    this.formItem[3].state = null;
                    this.dataForm.phone = value;
                    break;
                // check email empty but phone no empty
                case this.formItem[3].state !== null &&
                    name === "email" &&
                    value === "" &&
                    !isStrEmpty(phone):
                    this.formItem[3].state = null;
                    this.dataForm.email = "";
                    break;
                // check Incorrect email format
                case name === "email" &&
                    !isStrEmpty(value) &&
                    !validateEmail(value):
                    this.formItem[3].state = false;
                    this.formItem[3].textInvalid = this.getTranslatedText(
                        "correct email format"
                    );
                    this.dataForm.email = value;
                    break;
                // check email already exist
                case name === "email" &&
                    validateEmail(value) &&
                    value !== email &&
                    value !== "":
                    try {
                        const res = await authService.checkMail(value);

                        if (res.status === 400) {
                            let message = "";
                            res.errors.forEach((element) => {
                                message += element.message;
                            });
                            this.formItem[3].state = false;
                            this.formItem[3].textInvalid = message;
                        } else {
                            this.formItem[3].state = null;
                        }
                        this.dataForm.email = value;
                    } catch (error) {
                        this.formItem[3].textInvalid = error;
                    }
                    break;
                // check phone already exist and change code phone
                case (name === "phone" && value !== phone && value !== "") ||
                    !isStrEmpty(phoneCode):
                    // calling_code check change code phone

                    calling_code = !isStrEmpty(phoneCode)
                        ? phoneCode.replaceAll("\\+", "")
                        : calling_code.replaceAll("\\+", "");

                    try {
                        const res = await authService.checkPhone(
                            calling_code,
                            value
                        );
                        if (res.status === 400) {
                            let message = "";
                            res.errors.forEach((element) => {
                                message += element.message;
                            });
                            this.formItem[5].state = false;
                            this.formItem[5].textInvalid = message;
                        } else {
                            this.formItem[5].state = null;
                        }
                        this.dataForm.phone = value;
                        this.handleValidatePhoneNumber(this.phoneValidate);
                    } catch (error) {
                        this.formItem[5].textInvalid = error;
                    }
                    break;
                case (name === "phone" && value !== phone && value === ""):
                    this.dataForm.phone = ''
                   this.formItem[5].state = null;
                    this.handleValidatePhoneNumber(this.phoneValidate);
                default:
                    break;
            }
        },

        //update Date
        updateDate(date) {
            let dateFormat = date.split('.')

            let valueConvert = `${dateFormat[2]}/${dateFormat[1]}/${dateFormat[0]}`

            let dateFormatUTC = moment(valueConvert).format('MM/DD/YYYY')

            if (!isStrEmpty(this.textInvalidFeedbackDate) && moment(dateFormatUTC).format("YYYY-MM-DD") <= moment(this.maxDate).format("YYYY-MM-DD")) {
                this.textInvalidFeedbackDate = ''
            }
            this.dataForm.dob = dateFormatUTC
        },

        // update data resgister
        updateFormData(item) {
            let { value, name } = item;
            if (name !== "email" && name !== "phone") {
                this.dataForm[name] = value;
            }

            if(name === "email") {
                this.emailValidate = value
            }

            if(name === "phone") {
                this.phoneValidate = value
                this.handleValidatePhoneNumber(this.phoneValidate);
            }

            if(name === "full_name" && this.formItem[0].state === false && !isStrEmpty(value)) {
                this.formItem[0].state = null
            }

            switch (true) {
                case name === "full_name":
                    // eslint-disable-next-line no-case-declarations
                    let fullName = value.split(" ");

                    this.dataSynerise.firstName = fullName[0];
                    this.dataSynerise.lastName =
                        fullName.length > 1
                            ? fullName[fullName.length - 1]
                            : "";
                    break;
                case name === "phone":
                    // eslint-disable-next-line no-case-declarations
                    let calling_code = this.dataForm.calling_code.replaceAll(
                        "\\+",
                        ""
                    );

                    this.dataSynerise.phone = !isStrEmpty(value)
                        ? `${calling_code}${value}`
                        : "";
                    break;
                case name === "dob":
                    this.dataSynerise.birthdate =
                        moment(value).format("MM/DD/YYYY");
                    break;
                case name === "nationality":
                    // eslint-disable-next-line no-case-declarations
                    let indexNation = !isArrayEmpty(this.allCountries)
                        ? this.allCountries.findIndex((x) => x.code === value)
                        : -1;
                    this.dataSynerise.nationality =
                        indexNation !== -1
                            ? this.allCountries[indexNation].name
                            : "";

                    break;
                case name === "country_code":
                    // eslint-disable-next-line no-case-declarations
                    let indexCountry = !isArrayEmpty(this.allCountries)
                        ? this.allCountries.findIndex((x) => x.code === value)
                        : -1;
                    this.dataSynerise.country_of_residence =
                        indexCountry !== -1
                            ? this.allCountries[indexCountry].name
                            : "";
                    break;
                default:
                    break;
            }
        },

        // onSubmit confirm OTP
        async onSubmitConfirmOTp(dataOTP) {
            this.isLoadingButtonOTP = true;
            const { code } = dataOTP;
            const { email, phone } = this.dataForm;

            let calling_code = `${this.dataForm.code.replaceAll("\\+", "")}`;

            try {
                const resp = await authService.checkBoth(
                    "register",
                    email,
                    phone,
                    calling_code,
                    code
                );
                if (resp.status === 200) {
                    this.dataOTPCode = code;
                    this.step += 1;
                } else {
                    this.showToast(
                        this.getTranslatedText(resp.message),
                        "error"
                    );
                }
                this.isLoadingButtonOTP = false;
            } catch (err) {
                console.log(err, "err");
            }
        },

        // submit step resgister
        async onSubmitForm() {
            try {
                this.isLoadingButton = true
                let { calling_code, full_name } = this.dataForm;

                if (this.step === 1) {
                    if (isStrEmpty(full_name)) {
                        this.formItem[0].state = false
                        let scrollDiv = document.getElementById("register-fullName").offsetTop;
                        window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                        this.isLoadingButton = false
                        return false;
                    }

                    if (isStrEmpty(this.emailValidate) && isStrEmpty(this.phoneValidate)) {
                        this.formItem[3].state = false;
                        this.formItem[3].textInvalid = this.getTranslatedText("please enter email");
                        let scrollDiv = document.getElementById("register-email").offsetTop;
                        window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                        this.isLoadingButton = false
                        return false;
                    }

                    if(!isStrEmpty(this.emailValidate)) {
                        const res = await authService.checkMail(this.emailValidate);

                        if (res.status === 400) {
                            let scrollDiv = document.getElementById("register-email").offsetTop;
                            window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                            this.isLoadingButton = false
                            return false
                        }
                    }

                    if(!isStrEmpty(this.phoneValidate)) {
                        calling_code = calling_code.replaceAll("\\+", "");
                        const res = await authService.checkPhone(
                            calling_code,
                            this.phoneValidate
                        );

                        if (res.status === 400 || this.formItem[5].state === false) {
                            let scrollDiv = document.getElementById("register-phone").offsetTop;
                            window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                            this.isLoadingButton = false
                            return false
                        }
                    }

                    if(!this.dataForm.confirm) {
                        this.showToast(
                            this.getTranslatedText('Please accept our terms and conditions to continue!'),
                            "error"
                        );
                        this.isLoadingButton = false
                        return false
                    }


                    this.sendOTP();
                }

                window.scrollTo({ top: 0 });
                this.isLoadingButton = false
                this.step += 1;
            } catch (error) {
                    console.log(error)
                 this.isLoadingButton = false
            }
        },

        // on cancel resgister
        onClickCancel() {
            this.$router.push(`/home`);
        },

        // on click go back history
        onClickGoBack() {
            this.step = this.step === 3 ? 1 : this.step - 1;
        },

        changeNumber() {
            this.$router.push(`/home`);
        },

        // change phone code
        selectPhoneCode(item) {
            if (
                this.dataForm.calling_code !== item.number &&
                !isStrEmpty(this.dataForm.phone)
            ) {
                let event = {
                    target: {
                        value: this.dataForm.phone,
                        name: "phone",
                    },
                };

                let phoneCode = item.number;

                this.onBurInputFormData(event, phoneCode);
            }
            this.dataForm.calling_code = item.number;
            this.dataForm.code = item.number;
            this.dataForm.flag = item.flag;
            this.dataForm.nameCountry = item.name.replace(
                /^(.{5}[^\s]*).*/,
                "$1"
            );
            this.textSearchPhoneNumber = "";
            this.phoneNumbersFilter = phoneNumbers;
            this.handleValidatePhoneNumber(this.phoneValidate);
        },
        showDropDow() {
            const dropdown = this.$refs.select_phone_code;
            dropdown.show();
        },

        renderClass(number) {
            const className =
                number > this.maxiumBlue && number <= this.maxiumGreen
                    ? "ball-blue"
                    : "ball-green";

            return className;
        },

        onChangeFilterPhoneNumbers(value) {
            let phoneNumber = [...phoneNumbers];
            if (!isStrEmpty(value)) {
                this.phoneNumbersFilter = filterFullTextSearch(
                    phoneNumber,
                    value,
                    "name",
                    "number"
                );
            } else {
                this.phoneNumbersFilter = phoneNumber;
            }
            this.handleValidatePhoneNumber(this.phoneValidate);
        },

        renderNumber(number) {
            return renderLocaleNumber(number);
        },
    },
};
</script>
<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/authenticate/_register.scss"
/>
